import FnrTextLink from "UI/FnrTextLink";

/**
 * Drop this inside a FnrTypography to style the font.
 */
const FnrHelpEmailLink = () => (
  <FnrTextLink href="mailto:help@flocknote.com">help@flocknote.com</FnrTextLink>
);

export default FnrHelpEmailLink;
